<template>
  <div class="hideTotal">
    <table-search
      @search="fetchTableList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item label="日期">
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          />
        </el-form-item>
        <el-form-item label="主体">
          <el-select v-model="query.companyId">
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="exportExcel('PAYMENT')" />
    <el-table
      ref="zTable"
      :data="tableData"
      border
    >
      <el-table-column
        fixed
        label="序号"
        width="100px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="memberNumber"
        min-width="150"
        label="客户号"
      />
      <el-table-column
        fixed
        prop="bizDate"
        min-width="150"
        label="日期"
      >
        <template slot-scope="scope">
          {{ dayJs(scope.row.bizDate).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="overPurDeduct"
        min-width="150"
        label="预扣货款"
      />
      <el-table-column
        prop="earnestPurDeduct"
        min-width="180"
        label="定金采购预扣诚意金货款"
      />
      <el-table-column
        prop="deductGuarantee"
        min-width="150"
        label="暂扣质保金"
      />
      <el-table-column
        prop="deductInvoiceGuarantee"
        min-width="150"
        label="暂扣开票保证金"
      />
      <el-table-column
        prop="dayTotal"
        min-width="150"
        label="单日合计"
      />
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
import dayJs from 'dayjs'
import mixin from '@/utils/mixinFile'

import {
  getFirstDayOfCurrentMonth
} from '@/utils/util.js'

function Query () {
  this.endDate = ''
  this.beginDate = ''
  this.companyId = 'hCsAAAAAAYDM567U'
  this.memberNumber = ''
  this.date = [getFirstDayOfCurrentMonth(), new Date()]
  this.token = ''
}
export default {
  name: 'WithholdingPayment',
  mixins: [mixin],
  data () {
    return {
      // 分页数据
      currentNo: 1,
      total: 0,
      pageSize: 100,

      query: new Query(),
      tableData: [],
      // 主体数组
      companyList: [],
      dayJs: dayJs,
    }
  },
  async created () {
    api.spotPurchaseSaleInquiry.getToken().then((res) => {
      this.query.token = res
      this.query.memberNumber = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.account
      this.getAllCompany()
      this.fetchTableList()
    })
  },
  methods: {
    async fetchTableList () {
      if (!this.query.date.length) {
        this.$message.error('请输入开始结束时间')
        return
      }
      this.query.beginDate = `${dayJs(this.query.date[0]).format('YYYY-MM-DD')} 00:00:00`
      this.query.endDate = `${dayJs(this.query.date[1]).format('YYYY-MM-DD')} 23:59:59`

      let param = Object.assign({}, this.query, {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
      })

      let res = await api.spotPurchaseSaleInquiry.withholdingPaymentList(param)
      this.tableData = res.data
    },
    async getAllCompany () {
      this.companyList = (await api.spotPurchaseSaleInquiry.getAllCompany(this.query)).data
      // 取数组最后一个为默认主体
      // this.query.companyId = this.companyList[this.companyList.length && this.companyList.length - 1].id
    },
    handleReset () {
      this.query.endDate = ''
      this.query.beginDate = ''
      this.query.companyId = 'hCsAAAAAAYDM567U'
      this.query.date = [getFirstDayOfCurrentMonth(), new Date()]
      this.fetchGoodsData(1)
    },
    // 分页
    changePage (page) {
      this.fetchGoodsData(10, page)
    }
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep .z-table__content>div {
    border: none;
  }

  .pagination {
    float: right;
    margin: 20px 0;
  }

</style>
